import setupFeeMap  from "./setupFeeMap";

export default {
    methods:
    {
        recalcPrices() {
            this.$store.dispatch("Configuration/loadCO", {
              axios: this.$axios,
              pid: sessionStorage.getItem("pid"),
              billing: this.billing,
            });
          },
    },
    computed:
    {
      fieldHint()
      {
        return this.quantityCO?.options[0].recurring != '0.00' ? this.quantityCO?.options[0].name : ''
      },
        quantityCO() {
            return this.$store.state.Configuration.co.find(
              (i) => i.optionraw.trim().startsWith("quantity")
            );
          },
          price() {
            if (this.quantityCO) {
                const qty = this.quantity > 0 ? this.quantity : 1;
                const billingset = this.billing === 'onetime' ? 'monthly' : this.billing
                const price = 
                    parseInt(qty) * this.quantityCO?.options[0].recurring + 
                    parseFloat(
                        this.$store.state.Configuration?.pricing?.rawpricing[
                          billingset
                        ]
                      );
              return (
                this.setupFee + this.formatCurrency(price)
                
              );
            }
            return "";
          },
          setupFee() {
            if (this.billing) {
              let setupFee =
                this.quantityCO.selectedsetup +
                parseFloat(
                  this.$store.state.Configuration?.pricing?.rawpricing[
                    setupFeeMap[this.billing]
                  ]
                );
              return setupFee > 0.0
                ? this.formatCurrency(setupFee) + " setup + "
                : "";
            }
            return "";
          },

    }
}